/* Environment Map — NL Query Bar */
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChatCircle, PaperPlaneTilt, X } from '@phosphor-icons/react';
import { API } from '@/App';
import { toast } from 'sonner';

export function NLQueryBar({ onResult, onHighlight }) {
  var [query, setQuery] = useState('');
  var [loading, setLoading] = useState(false);
  var [lastAnswer, setLastAnswer] = useState(null);
  var [open, setOpen] = useState(false);

  function submit(e) {
    e.preventDefault();
    if (!query.trim() || loading) return;
    setLoading(true);
    fetch(API + '/map/query', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ query: query }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data) {
          setLastAnswer(data.answer);
          onHighlight(data.highlight_nodes || [], data.highlight_edges || []);
          if (data.action === 'impact_analysis' && data.highlight_nodes && data.highlight_nodes[0]) {
            onResult(data);
          }
        }
      })
      .catch(function () { toast.error('Map query failed'); })
      .finally(function () { setLoading(false); });
  }

  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 w-[400px]" data-testid="nl-query-bar">
      <form onSubmit={submit} className="flex items-center bg-kova-card/95 border border-kova-cyan/12 backdrop-blur-sm">
        <button type="button" onClick={function () { setOpen(!open); }} className="px-2 py-1.5 text-kova-cyan hover:bg-white/5">
          <ChatCircle size={14} weight={open ? 'fill' : 'regular'} />
        </button>
        <input value={query} onChange={function (e) { setQuery(e.target.value); }} placeholder='Ask: "What depends on Stripe?"' className="flex-1 bg-transparent text-[10px] font-mono text-white px-2 py-1.5 focus:outline-none placeholder:text-kova-slate" data-testid="nl-query-input" />
        <button type="submit" disabled={loading} className="px-2 py-1.5 text-kova-cyan hover:bg-white/5 disabled:opacity-40">
          {loading ? <span className="text-[10px] font-mono animate-pulse">...</span> : <PaperPlaneTilt size={14} />}
        </button>
      </form>
      <AnimatePresence>
        {lastAnswer && open && (
          <motion.div initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -4 }} className="mt-1 bg-kova-card/95 border border-kova-cyan/12 backdrop-blur-sm p-3" data-testid="nl-query-answer">
            <div className="flex items-start justify-between gap-2">
              <p className="text-[11px] text-kova-silv leading-relaxed">{lastAnswer}</p>
              <button onClick={function () { setLastAnswer(null); setOpen(false); onHighlight([], []); }} className="text-kova-slate hover:text-white shrink-0"><X size={12} /></button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
